import { TransformErrorMessageFn } from "@/components/form"

export const transformWrongCredentialsError: TransformErrorMessageFn =
  function handleTransformWrongCredentialsError(error) {
    const output: ReturnType<TransformErrorMessageFn> = { message: error }

    if (error.startsWith("Errors.invalidCredentials")) {
      // For PokerStars, this functionality is disabled because of an anti cheat policy that prevents the display of the number of attempts left.
      if (window.APP_VENDOR === "pokerstars") {
        return { message: "Errors.invalidCredentials" }
      }

      // Being only enabled for the remaining vendors, the message can be assumed to be in italian.
      const offset = error.lastIndexOf(".")
      const counter = Number(error.slice(offset + 1))

      output.message = error.slice(0, offset)
      output.messageProps = {
        counter: Number.isNaN(counter) ? "" : counter,
        left: counter > 1 ? "tentativi" : "tentativo",
      }
    }

    return output
  }
